import { Markup, MarkupPlugin } from '@technology/web3d-plugin-markup';
import { Web3DViewer } from '@technology/web3d';

/**
 * userData key linking a pane-rendered markup to its canonical annotation id.
 * Wedge toward NUMARK-1020: panes can be matched by id without embedded ref arrays.
 */
export const CANONICAL_ANNOTATION_ID_KEY = 'canonicalAnnotationId';

export function stampCanonicalId(
  viewerMarkup: Markup,
  canonicalId: string
): void {
  if (!viewerMarkup.userData) {
    viewerMarkup.userData = {};
  }
  viewerMarkup.userData[CANONICAL_ANNOTATION_ID_KEY] = canonicalId;
}

export function getCanonicalId(viewerMarkup: Markup): string | undefined {
  const id = viewerMarkup.userData?.[CANONICAL_ANNOTATION_ID_KEY];
  return typeof id === 'string' ? id : undefined;
}

export function hasCanonicalAnnotationOnViewer(
  viewer: Web3DViewer,
  canonicalId: string
): boolean {
  const markupPlugin = viewer.plugins.get(MarkupPlugin);
  if (!markupPlugin) {
    return false;
  }

  return markupPlugin
    .getMarkups()
    .some((m) => getCanonicalId(m) === canonicalId);
}
